exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body_order h4[data-v-005858de] {\r\n    margin-bottom: 32px;\n}\n.disabled[data-v-005858de] {\r\n    cursor: default;\r\n    background-color: #707070;\n}\n.disabled[data-v-005858de]:hover {\r\n    background-color: #707070;\n}\ninput[data-v-005858de] {\r\n    margin-bottom: 20px;\n}\r\n", ""]);

// exports
